module.exports = __webpack_public_path__ + "img/home-index-menu3.ef83a450.png";